// extracted by mini-css-extract-plugin
export default {"container":"WantBuySellList_container__5g-f7","box":"WantBuySellList_box__qP3bl","boxBtn":"WantBuySellList_boxBtn__ABdrc","titleBtn":"WantBuySellList_titleBtn__clIBP"};